import { useUserPermissions } from "@saleor/auth/hooks/useUserPermissions";
import { getPreviewOrderFilterTable } from "@saleor/createOrder/views/sort";
import {
  PermissionEnum,
  PreviewCustomerOrderQuery,
  PreviewDomesticPageOrderQuery,
  usePreviewCustomerOrderLazyQuery,
  usePreviewDomesticPageOrderLazyQuery
} from "@saleor/graphql";
import { useEffect, useMemo, useState } from "react";

export const useDataPreview = (id, params, valuesPaginationState, settings) => {
  const [dataPreview, setDataPreview] = useState<
    | PreviewCustomerOrderQuery["previewCustomerOrder"]
    | PreviewDomesticPageOrderQuery["previewDomesticPageOrder"]
  >();
  const [loadingPreviewOrder, setLoadingPreviewOrder] = useState<boolean>(true);
  const permissions = useUserPermissions();
  const extensionsPermissionDomestic = permissions?.find(
    perm => perm.code === PermissionEnum.VIEW_ORDER_DOMESTIC
  );
  const queryVariables = useMemo(
    () => ({
      id,
      ...valuesPaginationState,
      sortBy: getPreviewOrderFilterTable(params)
    }),
    [settings.rowNumber, valuesPaginationState, params, id]
  );

  const [
    getPreviewCustomerOrder,
    { data: dataPreviewCustomerOrder, refetch: refetchPreviewCustomer }
  ] = usePreviewCustomerOrderLazyQuery({
    fetchPolicy: "no-cache"
  });

  const [
    getPreviewDomesticOrder,
    { data: dataPreviewDomesticOrder }
  ] = usePreviewDomesticPageOrderLazyQuery({
    fetchPolicy: "no-cache"
  });

  useEffect(() => {
    if (extensionsPermissionDomestic) {
      getPreviewDomesticOrder({
        variables: queryVariables
      });
    } else {
      getPreviewCustomerOrder({
        variables: queryVariables
      });
    }
  }, [queryVariables]);

  useEffect(() => {
    if (dataPreviewCustomerOrder) {
      setDataPreview(dataPreviewCustomerOrder?.previewCustomerOrder);
      setLoadingPreviewOrder(false);
      return;
    }
    if (dataPreviewDomesticOrder) {
      setDataPreview(dataPreviewDomesticOrder?.previewDomesticPageOrder);
      setLoadingPreviewOrder(false);
      return;
    }
  }, [dataPreviewCustomerOrder, dataPreviewDomesticOrder]);

  return {
    dataPreview,
    loadingPreviewOrder,
    refetchPreviewCustomer
  };
};
